export const rowPerPageOptions = [5, 10, 25, 50, 100, 200, 500, 1000];
export const defaultPageSize = 1000;